module.exports = __webpack_public_path__ + "static/media/video-yardnapha-issue-one.4ad1e873.png";